// Server API URLs
const SERVER_URLS = {
	LOCAL: 'http://localhost:8080/menuu-dev/api',
	DEVELOPMENT: 'https://api.menuu.eu/menuu-dev/api',
	STAGING: 'https://api.menuu.eu/menuu/api',
	PRODUCTION: 'https://api.menuu.com/menuu/api',
	QA: 'https://api.menuu.eu/menuu-qa/api',
	AMAZON_DEV: 'http://api-dev.menuu.com/menuu-qa/api'
};

const FRONT_END_URLS = {
	LOCAL: 'http://localhost:3000',
	DEVELOPMENT: 'https://frontend-dev.menuu.eu',
	STAGING: 'https://frontend.menuu.eu',
	PRODUCTION: 'https://frontend.menuu.com',
	QA: 'https://frontend-qa.menuu.eu',
	AMAZON_DEV: 'http://frontend-dev.menuu.com'
};

export const SERVER_URL = SERVER_URLS.PRODUCTION; // SERVER_URLS.STAGING
export const FRONT_END_URL = FRONT_END_URLS.PRODUCTION; // FRONT_END_URL.STAGING
export const DEFAULT_PAGE_SIZE = 10; //10 for staging
export const DEFAULT_PAGING_RANGE = 3;

// Message levels
export const MESSAGE_LEVEL_ERROR = 0;
export const MESSAGE_LEVEL_SUCCESS = 1;
export const MESSAGE_LEVEL_DEFAULT = 2;

// Brand default values
export const DEFAULT_BRAND_NAME = 'My Brand';
export const DEFAULT_BRAND_DESCRIPTION = 'My brand description.';
export const DEFAULT_BRAND_CATEGORY_ID = 1;
export const DEFAULT_BRAND_THEME = 'LIGHT';
export const DEFAULT_BRANDS_PAGE_SIZE = 10;

// Manager Roles
export const RESTAURANT_MANAGER = 'RESTAURANT_MANAGER';
export const MENUU_ADMIN = 'MENUU_ADMIN';
export const MENUU_MASTER_ADMIN = 'MENUU_MASTER_ADMIN';
export const CHAIN_MANAGER = 'CHAIN_MANAGER';
export const CHAIN_ADMIN = 'CHAIN_ADMIN';

// Stripe client_id

// Dev
//export const STRIPE_CLIENT_ID = 'ca_DpecPkcCTMEAY3rBXlGYA8TpJuG5eOBJ';
// Production and staging
export const STRIPE_CLIENT_ID = 'ca_CzwAimwwmzgtwQkpoZXv0EwFsqesFhhQ';

// Map Integration
// Dev and staging
// export const GOOGLE_MAPS_API_KEY = 'AIzaSyC-g0fFlKbpC9o6d7Pk4Ec6BrT5joPTzcQ';
// Production
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDSzlwwJACmlQhi5jI9x4_Eqh8-CN8OBbQ';

// List of countries for the phone library.
// Аdd the countries in alphabetical order, not according to the abbreviation, but according to the name that we will display.
export const countryList = ["AR", "AU", "BE", "BG", "BR", "CA", "CL", "FR", "DE", "IE", "IN", "IT", "MT", "MX", "NL", "PL", "PT", "ES", "GB", "US"];

// Common Buttons
export const COMMON_BTN_COPY = 'copy';
export const COMMON_BTN_EDIT = 'edit';
export const COMMON_BTN_DELETE = 'delete';

//Promotions
export const PRICE_DISCOUNT = "PRICE_DISCOUNT";
export const COMBO_DEAL = "COMBO_DEAL";
export const FREE_PRODUCT = "FREE_PRODUCT";
export const ALL_MENU = "ALL_MENU";
export const INCLUDE = "INCLUDE";
export const EXCLUDE = "EXCLUDE";

// Menu Items
export const MENU_ITEM_TYPE_MENU = 'menu';
export const MENU_ITEM_TYPE_CATEGORY = 'category';
export const MENU_ITEM_TYPE_PRODUCT = 'product';
export const MENU_ITEM_TYPE_QUESTION = 'question';
export const MENU_ITEM_TYPE_ANSWER = 'answer';
export const MENU_ITEM_TYPE_DEALS = 'deals';
export const MENU_ITEMS_TYPES_PLURALS = {
	menu: 'menus',
	category: 'categories',
	product: 'products',
	question: 'questions',
	answer: 'answers',
	subQuestion: 'subQuestions',
	subAnswer: 'subAnswers'
}
export const MENU_ITEM_SUB_QUESTION = 'subQuestion';
export const MENU_ITEM_SUB_ANSWER = 'subAnswer';

// POS && Restaurant && Order status
export const ONLINE = 'ONLINE';
export const OFFLINE = 'OFFLINE';
export const PAUSED = 'PAUSED';
export const NOT_CONFIGURED = 'NOT_CONFIGURED';
export const CLOSED = 'CLOSED';
export const OPEN = 'OPEN';
export const FAIL = 'FAIL';
export const SUCCESS = 'SUCCESS';
export const REJECTED = 'REJECTED';
export const ACCEPTED = 'ACCEPTED';
export const PENDING = 'PENDING';
export const PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED';
export const CANCELED = 'CANCELED';
export const REFUNDED = 'REFUNDED';
export const INACTIVE = 'INACTIVE';

export const AUTO_SYNC = 'AUTO_SYNC';
export const IMPORT = 'IMPORT';
export const IMPORT_POS_ORDER_TYPES = 'IMPORT_POS_ORDER_TYPES';
export const IMPORT_POS_TENDER_TYPES = 'IMPORT_POS_TENDER_TYPES';
export const IMPORT_POS_CHARGE_TYPES = 'IMPORT_POS_CHARGE_TYPES';
export const PUBLISH = 'PUBLISH';
export const PUBLISH_MENU = 'PUBLISH_MENU';
export const PUBLISH_CATEGORY = 'PUBLISH_CATEGORY';
export const PUBLISH_PRODUCT = 'PUBLISH_PRODUCT';
export const PUBLISH_QUESTION = 'PUBLISH_QUESTION';
export const PUBLISH_ANSWER = 'PUBLISH_ANSWER';
export const WIPE_MENU = 'WIPE_MENU';
export const PAUSE_ALL_RESTAURANTS = 'PAUSE_ALL_RESTAURANTS';
export const PRODUCT_REPORT = 'PRODUCT_REPORT';
export const DOWNLOAD_ORDERS_REPORT = 'DOWNLOAD_ORDERS_REPORT';
export const CENTRAL_SEARCH_ORDER_REPORT = 'CENTRAL_SEARCH_ORDER_REPORT';
export const SEND_ORDER_TO_DELIVERY_PARTNER_FAILURE = 'SEND_ORDER_TO_DELIVERY_PARTNER_FAILURE';

export const CREATE_ORDER = 'CREATE_ORDER';
export const CREATE_BILLING_CSV = 'CREATE_BILLING_CSV';
export const IMPORT_IIKO_ADDRESSES = 'IMPORT_IIKO_ADDRESSES';
export const CREATE_CUSTOMER_DATA_CSV = 'CREATE_CUSTOMER_DATA_CSV'
export const CREATE_INVOICE_HISTORY_CSV = 'CREATE_INVOICE_HISTORY_CSV'; // admin and master admin
export const DELIVERY_PROVIDER_ERROR = 'DELIVERY_PROVIDER_ERROR';

// Notifications
export const IMPORT_FAILED = 'IMPORT_FAILED';
export const IMPORT_COMPLETED = 'IMPORT_COMPLETED';
export const PUBLISH_FAILED = 'PUBLISH_FAILED';
export const PUBLISH_COMPLETED = 'PUBLISH_COMPLETED';
export const RESTAURANT_PAUSED = 'RESTAURANT_PAUSED';
export const POS_OFFLINE = 'POS_OFFLINE';
export const REJECTED_ORDER = 'REJECTED_ORDER';
export const AUTO_SYNC_FAILED = 'AUTO_SYNC_FAILED';
export const EMAIL_SENDING_FAIL = 'EMAIL_SENDING_FAIL';
export const SMS_SENDING_FAIL = 'SMS_SENDING_FAIL';
export const BILLING_CSV_FAIL = 'BILLING_CSV_FAIL';
export const PENDING_IN_PROCESS = 'PENDING_IN_PROCESS';
export const PENDING_FUTURE_ORDER = 'PENDING_FUTURE_ORDER';
export const EXPORT_MENU_FAIL = 'EXPORT_MENU_FAIL';
export const URGENT_ORDER = 'URGENT_ORDER';
export const UPDATE_POS_SETTINGS_FAIL = 'UPDATE_POS_SETTINGS_FAIL';
export const UPDATE_POS_SETTINGS = 'UPDATE_POS_SETTINGS';
export const WIPE_MENU_FAIL = 'WIPE_MENU_FAIL';

// JOBS
export const MULTI = 'MULTI';

// Language abbreviations
export const US = 'US';
export const GB = 'GB';
export const IE = 'IE';
export const DE = 'DE';
export const NL = 'NL';
export const BE = 'BE';
export const FR = 'FR';
export const BG = 'BG';
export const CA = 'CA';
export const MT = 'MT';
export const BR = 'BR';
export const PT = 'PT';
export const IT = 'IT';
export const ES = 'ES';
export const PL = 'PL';
export const AU = 'AU';
export const IN = 'IN';
export const MX = "MX";
export const AR = "AR";
export const CL = "CL";

// Promotion screens
export const MINIMUM_ORDER_AMOUNT = 'MINIMUM_ORDER_AMOUNT';
export const MINIMUM_NUMBER_OF_ITEMS = 'MINIMUM_NUMBER_OF_ITEMS';
export const AUTO_APPLY = 'AUTO_APPLY';

// QuestionScreen - may apply to other MenuConfigScreens if they get refactored
export const ADDITIONAL = 'additional';
export const ALLERGENS = 'allergens';
export const DIETARY = 'dietary';
export const NUTRIENTS = 'nutrients';
export const AVAILABILITY = 'availability';

export const ANDROMEDA_POS_TYPE_ID = 1;
export const MENUU_POS_TYPE_ID = 2;
export const GOODCOM_POS_TYPE_ID = 3;
export const CAPTIVA_TYPE_ID = 4;
export const PAR_PIXELPOINT_TYPE_ID = 5;

// Order Type Constants
export const DELIVERY_ID = 1;
export const COLLECTION_ID = 2;
export const CURBSIDE_ID = 4;
export const INSTORE_ID = 5;

// Payment Type Constants
export const CREDIT_CARD_ID = 1;
export const CASH_ID = 2;
export const SIMPLE_BILLING = "SIMPLE_BILLING";
export const ADVANCED_BILLING = "ADVANCED_BILLING";

// Restaurant Priority Level Constants
export const LOW = 'LOW';
export const MEDIUM = 'MEDIUM';
export const HIGH = 'HIGH';

// List of supported languages
export const languageList = ["GB", "BG", "FR", "IT", "ES"];

// Currency List
export const currencyList = ["usd", "cad", "eur", "gbp", "aud", "mxn", "ars", "clp", "bgn"];

// Area List
export const areaList = ["EU", "UK", "US", "CA", "AU", "MX", "AR", "CL"];

//System Additional Charges Types
export const systemAdditionalChargesList = ["SMS fees", "Menuu Service Fee"];


// WEBPACK FOOTER //
// ./src/utils/Constants.js